export const config = {
  title: "DH Mobile Mechanics LLC | Louisville, KY",
  meta: {
    description:
      "DH Mobile Mechanics LLC offers top-notch mobile mechanic services in Louisville, Kentucky. We provide oil changes, brake repair, engine diagnostics, and maintenance for all types of vehicles. Quality service that comes to you!",
    keywords: [
      "DH Mobile Mechanics LLC",
      "Mobile Mechanic Louisville KY",
      "Car Repair Louisville",
      "Oil Change Louisville",
      "Brake Repair Kentucky",
      "Engine Diagnostics",
      "Mobile Auto Repair",
      "Louisville Mechanic",
      "On-Site Car Repair",
      "Vehicle Maintenance Louisville"
    ],
    author: "DH Mobile Mechanics LLC",
    canonicalUrl: "https://www.dhmobilemechanicsllc.com/",
  },
  sections: {
    header: {
      businessName: "DH Mobile Mechanics LLC",
    },
    sectionB: {
      heroTitle: "Quality Mobile Mechanic Service That Comes to You",
      heroSubtitle: "Expert Auto Repair & Maintenance in Louisville, Kentucky",
      learnAboutText: "Book an Appointment",
      phoneNumber: "5024571988",
      phoneLabel: "(502) 457-1988",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?q=80&w=2032&auto=format&fit=crop",
      cardData: [
        {
          title: "Oil Change",
          description:
            "Keep your engine running smoothly with high-quality oil and filter replacements for peak performance.",
        },
        {
          title: "Brake Repair",
          description:
            "Expert brake pad replacement and rotor resurfacing to ensure optimal braking performance and safety.",
        },
        {
          title: "Engine Diagnostics",
          description:
            "Advanced diagnostic tools to identify and resolve engine issues, keeping your vehicle in top condition.",
        },
      ],
      description:
        "DH Mobile Mechanics LLC is a dedicated mobile mechanic service based in Louisville, Kentucky. We offer top-notch repair and maintenance services for all types of vehicles, prioritizing customer satisfaction and using only the best manufacturer parts.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Professional mobile mechanic services that come to your location. We get you back on the road quickly and efficiently.",
      cards: [
        {
          title: "Oil Change",
          description:
            "High-quality oil and filter replacements to ensure your engine runs smoothly and maintains peak performance.",
          imageSrc: "https://images.unsplash.com/photo-1487754180451-c456f719a1fc?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "Oil Change Service",
        },
        {
          title: "Brake Repair",
          description:
            "Professional brake pad replacement and rotor resurfacing to ensure optimal braking performance and your safety on the road.",
          imageSrc: "https://images.unsplash.com/photo-1625047509168-a7026f36de04?q=80&w=2080&auto=format&fit=crop",
          imageAlt: "Brake Repair Service",
        },
        {
          title: "Engine Diagnostics",
          description:
            "Advanced diagnostic tools and expert analysis to identify and resolve engine issues efficiently, keeping your vehicle in top condition.",
          imageSrc: "https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?q=80&w=2074&auto=format&fit=crop",
          imageAlt: "Engine Diagnostics Service",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Vehicle Maintenance",
        "Preventative Care",
        "Fluid Checks & Replacements",
        "Battery Service",
        "On-Site Repairs",
      ],
    },
    sectionD: {
      aboutTitle: "About DH Mobile Mechanics LLC",
      aboutImage: {
        src: "https://primary.jwwb.nl/pexels/75/7564861.jpeg?enable-io=true&enable=upscale&crop=1067%2C1280%2Cx427%2Cy0%2Csafe&width=340&height=408",
        alt: "DH Mobile Mechanics Team",
      },
      aboutText: [
        "DH Mobile Mechanics LLC is a locally-owned and operated mobile mechanic service in Louisville, Kentucky. With years of experience in the industry, we prioritize customer satisfaction and quality service above all else. Our team of skilled technicians is dedicated to providing efficient and reliable repair and maintenance services for all types of vehicles.",
        "We come to you, whether you're at home, work, or stranded on the road. Our priority is to get you back on the road quickly and efficiently, using only the best manufacturer parts for every repair. Experience the convenience of professional auto service at your location.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "DH Mobile Mechanics LLC",
      businessName: "DH Mobile Mechanics LLC",
      contact: {
        phone: "5024571988",
        phoneLabel: "(502) 457-1988",
        email: "daltonhollenbach6@gmail.com",
        website: "https://www.dhmobilemechanicsllc.com/",
        address: "Louisville, KY",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Louisville, KY",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d199444.8!2d-85.7585!3d38.2527!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88690b1ab35bd511%3A0xd4d3b4282071fd32!2sLouisville%2C%20KY!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;